import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { registerOfMembersDocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const RegisterOfMembersFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={registerOfMembersDocumentTypesArray}
        placeholder="Select a register of members document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default RegisterOfMembersFormValues;
